export const MAXIMUM_UPLOAD_IMAGE_SIZE = 1024 * 1024; // 1 Mb into bytes

export const MAX_UPLOAD_VIDEO_SIZE = 1024 * 1024 * 200; // 200mb in bytes
